import React, {h, Component} from 'preact';
import {PropTypes} from 'preact-compat';
import _ from 'lodash';

export default class LoginLinkStep extends Component {
    static get propTypes() {
        return {
            address: PropTypes.string,
            name: PropTypes.string,
            email: PropTypes.string,
            requestId: PropTypes.number,
            isBuyer: PropTypes.bool,
        };
    }

    state = {
        sendButtonText: 'Send me the link again',
        isSendButtonEnabled: true
    };

    componentDidMount() {
        this.sendLoginLinkSilent();
    }

    sendLoginLinkSilent() {
        return $.post('send-login-link-json', {
            email: this.props.email,
            requestId: this.props.requestId,
            buyerPage: this.props.isBuyer
        });
    }

    sendLoginLink() {
        return $.post('send-login-link-json', {
            email: this.props.email,
            requestId: this.props.requestId,
            buyerPage: this.props.isBuyer
        }).then(data => {
            if (!checkAjax(data)) {
                return;
            }
            this.setState({
                sendButtonText: 'Link sent!',
                isSendButtonEnabled: false
            });
            setTimeout(() => {
                this.setState({
                    sendButtonText: 'Send me the link again',
                    isSendButtonEnabled: true
                });
            }, 30000);
        });
    }

    render() {
        return (
            <div className="flow-step login-link-step">
                <img src={global.imageBaseUrl + 'user/login_mail.svg'}/>
                <div className="title">
                    Check your inbox to continue.
                </div>
                <div className="message">
                    Welcome back, {this.props.name}!<br/>
                    We found your previous agent search at:<br/>
                    <div className="address">
                        <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fillRule="evenodd" clipRule="evenodd" d="M7.91321 11.8092C10.535 11.8092 12.6604 9.76257 12.6604 7.23788C12.6604 4.71318 10.535 2.6665 7.91321 2.6665C5.29141 2.6665 3.16602 4.71318 3.16602 7.23788C3.16602 9.76257 5.29141 11.8092 7.91321 11.8092Z" stroke="#3578B9" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M11.2695 10.4712L14.2429 13.3334" stroke="#3578B9" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                        {this.props.address}
                    </div>
                    To continue, click on the link inside the email we sent to <span className="email">{this.props.email}</span>.
                </div>
                <ul className="email-services">
                    <li>
                        <a target="_blank" rel="noreferrer" href="https://mail.google.com" className="touch-opacity">
                            <img src={global.imageBaseUrl + 'user/email_gmail.svg'}/>
                            <span>Open Gmail</span>
                        </a>
                    </li>
                    <li>
                        <a target="_blank" rel="noreferrer" href="https://mail.yahoo.com" className="touch-opacity">
                            <img src={global.imageBaseUrl + 'user/email_yahoo.svg'}/>
                            <span>Open Yahoo</span>
                        </a>
                    </li>
                    <li>
                        <a target="_blank" rel="noreferrer" href="https://outlook.live.com" className="touch-opacity">
                            <img src={global.imageBaseUrl + 'user/email_outlook.svg'}/>
                            <span>Open Outlook</span>
                        </a>
                    </li>
                </ul>
                <div className="bottom">
                    <b className="visible-xs-inline-block text-semibold">Didn&apos;t receive the link?</b>
                    &nbsp;
                    <button
                        type="button"
                        className="visible-xs-inline-block touch-opacity send-button"
                        disabled={!this.state.isSendButtonEnabled}
                        onClick={this.sendLoginLink.bind(this)}>
                        {this.state.sendButtonText}
                    </button>
                    <div className="hidden-xs">
                        Didn&apos;t receive?
                        &nbsp;
                        <button
                            type="button"
                            className="touch-opacity send-button"
                            disabled={!this.state.isSendButtonEnabled}
                            onClick={this.sendLoginLink.bind(this)}>
                            {this.state.sendButtonText}
                        </button>
                    </div>
                    <div className="status-normal">
                        (check your spam folder)
                    </div>
                </div>
            </div>
        );
    }
}
